/** SCE / SoCalGas observed components for Beverly Hills (2021–2023). */
export interface BhSceElecYear {
  year: number;
  residential: number;
  commercial: number;
  industrial: number | null;
  agricultural: number | null;
}

export interface BhSoCalGasYear {
  year: number;
  residential: number;
  commercial: number;
  industrial: null;
}

export const BH_SCE_ELECTRICITY_OBSERVED: BhSceElecYear[] = [
  {
    year: 2021,
    residential: 164_516_997.314134,
    commercial: 215_662_959.789212,
    industrial: 76_380_658.3889465,
    agricultural: null,
  },
  {
    year: 2022,
    residential: 168_323_641.93636,
    commercial: 215_784_452.491684,
    industrial: 86_822_422.6783503,
    agricultural: null,
  },
  {
    year: 2023,
    residential: 159_117_581.361584,
    commercial: 213_524_034.846624,
    industrial: 82_278_347.1182167,
    agricultural: null,
  },
];

export const BH_SOCAL_GAS_OBSERVED: BhSoCalGasYear[] = [
  { year: 2021, residential: 11_277_216, commercial: 4_655_561, industrial: null },
  { year: 2022, residential: 10_292_770, commercial: 4_694_623, industrial: null },
  { year: 2023, residential: 11_081_745, commercial: 5_312_227, industrial: null },
];

export function sceObservedByYear(year: number): BhSceElecYear | undefined {
  return BH_SCE_ELECTRICITY_OBSERVED.find((r) => r.year === year);
}

export function soCalGasObservedByYear(year: number): BhSoCalGasYear | undefined {
  return BH_SOCAL_GAS_OBSERVED.find((r) => r.year === year);
}

export function sceNonresidentialTotal(row: BhSceElecYear): number {
  let sum = row.commercial;
  if (row.industrial != null) sum += row.industrial;
  if (row.agricultural != null) sum += row.agricultural;
  return sum;
}
